import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./RegisteredInfoPage.scss";

export default function RegisteredInfoPage() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="registered-info-page">
      <div className="registered-info-wrapper">
        <div className="registered-info-container breathing-text-wrapper">
          <h1>
            {t("registeredInfo.title", {
              defaultValue: "Vaše registrace byla úspěšná",
            })}
          </h1>

          <p>
            {t("registeredInfo.text1", {
              defaultValue:
                "Administrátor ji posoudí do 1 pracovního dne. Po schválení vám bude umožněn přístup ke stažení aktuálního firmware či příslušné dokumentace.",
            })}
            <br />
            {t("registeredInfo.text2", {
              defaultValue:
                "O výsledku vás budeme informovat e-mailem, který jste uvedli při registraci.",
            })}
          </p>

          <p className="registered-info-note">
            <strong className="registered-info-note__title">
              {t("registeredInfo.noteLabel", {
                defaultValue: "📩 Zkontrolujte také složku:",
              })}
            </strong>
            <br />
            <span className="highlight-mail">
              {t("registeredInfo.noteSpam", {
                defaultValue: "Spam",
              })}
            </span>
            <span className="registered-info-note__separator"> / </span>
            <span className="highlight-mail">
              {t("registeredInfo.noteBulk", {
                defaultValue: "Hromadné",
              })}
            </span>
          </p>

          <p className="registered-info-thanks">
            {t("registeredInfo.thanks", {
              defaultValue: "Děkujeme.",
            })}
          </p>
        </div>
      </div>
    </div>
  );
}
